/* istanbul ignore file */

import { defineMessages } from 'react-intl';

import { NotificationCategoryType } from './hooks/types';

// ─────────────────────────────────────────────────────────────────────

export const CATEGORY_MESSAGES: Record<
  NotificationCategoryType,
  ReturnType<typeof defineMessages>
> = {
  [NotificationCategoryType.OrderStatus]: defineMessages<CategoryMessageKey>({
    title: {
      defaultMessage: 'Order Updates',
      description: 'Notifications | Order Updates | Title',
    },
    subtitle: {
      defaultMessage: 'Stay updated on the status of your order',
      description: 'Notifications | Order Updates | Subtitle',
    },
  }),
  [NotificationCategoryType.Marketing]: defineMessages<CategoryMessageKey>({
    title: {
      defaultMessage: 'Sweetgreen offers',
      description: 'Notifications | Sweetgreen offers | Title',
    },
    subtitle: {
      defaultMessage:
        'Choose how to get special offers, promos, and personalized suggestions',
      description: 'Notifications | Sweetgreen offers | Subtitle',
    },
  }),
};

export const messages = defineMessages({
  title: {
    defaultMessage: 'Notifications',
    description: 'Notifications | Title',
  },
  pushNotificationsText: {
    defaultMessage: 'Push Notifications',
    description: 'Notifications | Push Notifications',
  },
  emailNotificationText: {
    defaultMessage: 'Email',
    description: 'Notifications | Email',
  },
  pushDisabledNoticeTitle: {
    defaultMessage:
      'Turn on push notifications from your device settings to see notifications from sweetgreen',
    description: 'Notifications | Push Notification | Disabled Text',
  },
  pushDisabledNoticeActionTitle: {
    defaultMessage: 'Go to device settings',
    description: 'Notifications | Push Notification | Action Text',
  },
  updateErrorText: {
    defaultMessage:
      'We couldn’t save your preferences. Please try again in a moment.',
    description: 'Notifications | Update Error Text',
  },
  updateErrorButtonText: {
    defaultMessage: 'Try again',
    description: 'Notifications | Update Error | Refetch button text',
  },
});

// ─── Types ───────────────────────────────────────────────────────────

type CategoryMessageKey = 'title' | 'subtitle';
